export const Environments = {
  PRODUCTION: "production",
  PREVIEW: "preview",
  DEV: "dev",
  TEST: "test",
  LOCAL: "local",
} as const;

export type Environment = (typeof Environments)[keyof typeof Environments];

export function getEnvironment(test: string): Environment {
  switch (test) {
    case Environments.DEV.toString():
      return Environments.DEV;

    case Environments.PREVIEW.toString():
      return Environments.PREVIEW;

    case Environments.TEST.toString():
      return Environments.TEST;

    case Environments.LOCAL.toString():
      return Environments.LOCAL;

    case Environments.PRODUCTION.toString():
    default:
      return Environments.PRODUCTION;
  }
}
